import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { deprecated } from 'prop-types-extra';
import classNames from 'classnames';
import { withStyles } from '@jpmuitk/theme';
import Icon from "@jpmuitk/icon/es/Icon";
import { style } from './style';
/**
 * Links are a fundamental navigation element. When clicked, they take the user to an entirely different page.
 *
 * @example
 * <LinkExample to="#link">Action</LinkExample>
 */

var Link = /*#__PURE__*/forwardRef(function Link(_ref, ref) {
  var href = _ref.href,
      className = _ref.className,
      classes = _ref.classes,
      disabled = _ref.disabled,
      label = _ref.label,
      children = _ref.children,
      target = _ref.target,
      rest = _objectWithoutProperties(_ref, ["href", "className", "classes", "disabled", "label", "children", "target"]);

  var iconClasses = {
    root: classes.icon
  };
  return /*#__PURE__*/React.createElement("a", _assign({
    className: classNames(className, classes.root, _defineProperty({}, classes.disabled, disabled)),
    href: disabled ? null : href,
    ref: ref,
    target: target
  }, rest), label || children, target && target === '_blank' && /*#__PURE__*/React.createElement(Icon, {
    accessibleText: "External Link",
    classes: iconClasses,
    name: "tear-out"
  }));
});
process.env.NODE_ENV !== "production" ? Link.propTypes = {
  /**
   * The content of the link.
   */
  children: PropTypes.node,

  /**
   * The className(s) of the component
   */
  className: PropTypes.string,

  /**
   * material-ui
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * If `true`, the link will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * A string to indicate the link url
   */
  href: PropTypes.string.isRequired,

  /**
   * @deprecated
   * This prop is deprecated, use `children` instead.
   * A string to indicate the link text
   */
  label: deprecated(PropTypes.string, 'Use `children` instead'),

  /**
   * A string to indicate the link target
   * Creates an Icon to the right of link if '_blank'
   */
  target: PropTypes.string
} : void 0;
Link.defaultProps = {
  target: '_self'
}; // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(style, {
  name: 'Link'
})(Link);